module.exports = __webpack_public_path__ + "img/x.715e4b53.svg";